import { AuthDividerWrapper, AuthDividerLine, AuthDividerText } from './styled';

export interface AuthDividerProps {
  text?: string;
}

/**
 * Visual divider with optional centered text for auth forms.
 */
export function AuthDivider({ text = 'or' }: AuthDividerProps) {
  return (
    <AuthDividerWrapper>
      <AuthDividerLine />
      <AuthDividerText>{text}</AuthDividerText>
      <AuthDividerLine />
    </AuthDividerWrapper>
  );
}
